require('./brokerPensionPlanPeriodicalContributionCancelView.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { ContentBox } = require('commonsComponents/contentBox');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @actions
const brokerPensionPlansActions = require('actions/brokerPensionPlans');
const BrokerPensionPlanPeriodicalContributionActions = require('actions/brokerPensionPlanPeriodicalContribution');
const brokerProductAdvancedSearchActions = require('actions/brokerProductAdvancedSearch');

// @components
const BrokerPensionPlanHeader = require('components/broker/brokerPensionPlanHeader/brokerPensionPlanHeader');
const BrokerPensionPlanPeriodicCancelSummary = require('components/broker/brokerPensionPlanContribution/pensionPlanPeriodic/pensionPlanPeriodicCancelSummary/pensionPlanPeriodicCancelSummary');
const BrokerPensionPlanPeriodicCancelSuccess = require('components/broker/brokerPensionPlanContribution/pensionPlanPeriodic/pensionPlanPeriodicCancelSuccess/pensionPlanPeriodicCancelSuccess');

// @constants
const {
    BROKER_PLANS_HELP_URL,
    MYPROFILE_BROKER_URL,
    MYPROFILE_BROKER_PLANS_URL,
    PLANS_ACTIVE,
    MYPROFILE_BROKER_PENSION_PLAN_PERIODICAL_CONTRIBUTION_URL
} = require('constants/index');

class BrokerPensionPlanPeriodicalContributionCancelView extends React.Component {

    constructor(props) {
        super(props);
        this.getContribution = this.getContribution.bind(this);
    }

    componentWillMount() {
        const { planId, contributionDate } = this.props.match.params;
        const { getPensionPlan, getPeriodicalContribution, getPeriodicalContributionDetails, history } = this.props;
        const getPensionPlanPromise = getPensionPlan(planId);
        const getContribution = this.getContribution;
        getPensionPlanPromise.then(() => {
            const getPeriodicalContributionPromise = getPeriodicalContribution();
            getPeriodicalContributionPromise.then(() => {
                const contribution = getContribution();
                if (contribution) {
                    const product = contribution.getIn(['contrato', 'producto']);
                    const contract = contribution.getIn(['contrato', 'numerodecontrato']);
                    const timeStamp = contributionDate;
                    const tipoApor = contribution.getIn(['planAportacion', 'tipo']);
                    const revalAnual = contribution.getIn(['planAportacion', 'revalorizacionAnual']);
                    getPeriodicalContributionDetails(product, contract, timeStamp, tipoApor, revalAnual)
                } else {
                    history.push(MYPROFILE_BROKER_PENSION_PLAN_PERIODICAL_CONTRIBUTION_URL);
                }

            }).catch(() => { });
        }).catch(() => { });
    }

    componentWillUnmount() {
        this.props.clearSearchResults();
    }

    getContribution() {
        const { immBrokerPensionPlanPeriodicalContribution, match: { params: { planId, contributionDate } } } = this.props;
        const contribution = immBrokerPensionPlanPeriodicalContribution.get('periodicalContributionList').find(item =>
            item.get('producto') === planId.substring(4, 7) &&
            item.getIn(['planAportacion', 'timestampAlta']) === contributionDate &&
            item.getIn(['planAportacion', 'situacion']) === PLANS_ACTIVE
        );
        return contribution;
    }

    buildWizard(pensionPlan) {
        const { validatePeriodicCancelContribution, immBrokerPensionPlanPeriodicalContribution } = this.props;
        const cancelPeriodicPlanTitle = <FormattedText value="pensionPlanContribution-cancelPeriodicContributionTitle" />
        return (
            <ContentBox title={cancelPeriodicPlanTitle}>
                <BrokerPensionPlanPeriodicCancelSummary
                    plan={pensionPlan}
                    validatePeriodicCancelContribution={validatePeriodicCancelContribution}
                    immBrokerPensionPlanPeriodicalContribution={immBrokerPensionPlanPeriodicalContribution}
                />
            </ContentBox>
        );
    }

    buildSuccessful(pensionPlan) {
        const { immBrokerPensionPlanPeriodicalContribution } = this.props;
        return (
            <div className="row no-gutter">
                <div className="col-lg-12">
                    <BrokerPensionPlanPeriodicCancelSuccess
                        plan={pensionPlan}
                        immBrokerPensionPlanPeriodicalContribution={immBrokerPensionPlanPeriodicalContribution}
                    />
                </div>
            </div>
        );
    }

    render() {
        const { immBrokerProductAdvancedSearch, immPensionPlan, immBrokerPensionPlanPeriodicalContribution } = this.props;
        const contribution = this.getContribution();
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('plans-plans'),
                url: MYPROFILE_BROKER_PLANS_URL
            },
            {
                text: formatText('pensionPlanPeriodicalContribution-breadcrumbCancelLink')
            }
        ];

        const headerTitle = formatText('pensionPlanContribution-titleCancel');
        let content = <LoadingSection />;
        let bodyContent = null;
        if (immBrokerPensionPlanPeriodicalContribution.getIn(['details', 'success']) == true) {
            content = <BrokerPensionPlanHeader immPensionPlan={immPensionPlan} immBrokerProductAdvancedSearch={immBrokerProductAdvancedSearch} />;
            if (!immBrokerPensionPlanPeriodicalContribution.get('submitCancelSuccesful')) {
                bodyContent = this.buildWizard(contribution);
            }
            if (immBrokerPensionPlanPeriodicalContribution.get('submitCancelSuccesful')) {
                bodyContent = this.buildSuccessful(contribution);
            }
        }

        return (
            <section className="broker-pension-plan-contribution-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        finalTitle={headerTitle}
                        breadcrumbConfig={mappingBreadcrumb}
                    >
                        <OKButton
                            inverse={true}
                            modifier="ghost"
                            to={BROKER_PLANS_HELP_URL}
                        >
                            <FormattedText value="pensionPlanContribution-headerSecondLink" />
                        </OKButton>
                    </OKHeaderSubPage>
                </OKCover>
                <section className="broker-pension-plan-contribution-view__body">
                    {content}
                    <div className="broker-pension-plan-contribution-view__wizard">
                        {bodyContent}
                    </div>
                </section>
            </section>
        );
    }
}

BrokerPensionPlanPeriodicalContributionCancelView.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    immBrokerPensionPlanPeriodicalContribution: PropTypes.object.isRequired,
    immBrokerProductAdvancedSearch: PropTypes.object.isRequired,
    immPensionPlan: PropTypes.object.isRequired,
    getPensionPlan: PropTypes.func.isRequired,
    getPeriodicalContribution: PropTypes.func,
    validatePeriodicCancelContribution: PropTypes.func.isRequired,
    getPeriodicalContributionDetails: PropTypes.func.isRequired,
    clearSearchResults: PropTypes.func.isRequired,
};

module.exports.constructor = BrokerPensionPlanPeriodicalContributionCancelView;
module.exports.BrokerPensionPlanPeriodicalContributionCancelView = connect(
    state => ({
        immPensionPlan: state.brokerPensionPlans,
        immBrokerPensionPlanPeriodicalContribution: state.brokerPensionPlanPeriodicalContribution,
        immBrokerProductAdvancedSearch: state.brokerProductAdvancedSearch,
    }), {
    getPeriodicalContribution: BrokerPensionPlanPeriodicalContributionActions.getPeriodicalContribution,
    getPensionPlan: brokerPensionPlansActions.requestPensionPlan,
    validatePeriodicCancelContribution: BrokerPensionPlanPeriodicalContributionActions.validatePeriodicCancelContribution,
    getPeriodicalContributionDetails: BrokerPensionPlanPeriodicalContributionActions.getPeriodicalContributionDetails,
    clearSearchResults: brokerProductAdvancedSearchActions.clearResults,

}
)(withRouter(BrokerPensionPlanPeriodicalContributionCancelView));
